import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Footer } from "../components/Footer";
import { COMPANY } from "../constants";

export const LegalHeader = () => (
  <header className="bg-white border-b border-gray-100" data-testid="legal-header">
    <div className="max-w-7xl mx-auto px-5 sm:px-8 h-[72px] flex items-center justify-between">
      <Link to="/" aria-label="Zur Startseite" data-testid="legal-logo">
        <img src="/assets/emt-logo.png" alt="EMT-Reinigung Logo" className="h-10 w-auto" width="542" height="218" />
      </Link>
      <Link
        to="/"
        className="inline-flex items-center gap-2 text-sm font-medium text-brand hover:text-brand-dark transition-colors"
        data-testid="legal-back-home"
      >
        <ArrowLeft className="w-4 h-4" />
        Zurück zur Startseite
      </Link>
    </div>
  </header>
);

export default function Impressum() {
  return (
    <>
      <LegalHeader />
      <main className="bg-white py-16 md:py-24">
        <div className="max-w-3xl mx-auto px-5 sm:px-8" data-testid="impressum-page">
          <h1 className="font-heading text-4xl sm:text-5xl font-semibold tracking-tight text-ink">Impressum</h1>

          <div className="mt-10 space-y-8 text-base text-mutedtext leading-relaxed">
            <section>
              <h2 className="font-heading text-xl sm:text-2xl font-medium text-ink mb-3">Angaben zum Unternehmen</h2>
              <p>
                {COMPANY.name}
                <br />
                Inhaber: {COMPANY.owner}
                <br />
                <br />
                {COMPANY.street}
                <br />
                {COMPANY.city}
                <br />
                Deutschland
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl sm:text-2xl font-medium text-ink mb-3">Kontakt</h2>
              <p>
                Telefon: {COMPANY.phoneIntl}
                <br />
                E-Mail:{" "}
                <a href={`mailto:${COMPANY.email}`} className="text-brand underline underline-offset-2">
                  {COMPANY.email}
                </a>
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl sm:text-2xl font-medium text-ink mb-3">
                Verantwortlich für den Inhalt
              </h2>
              <p>
                {COMPANY.owner}
                <br />
                {COMPANY.street}
                <br />
                {COMPANY.city}
              </p>
            </section>

            <section>
              <h2 className="font-heading text-xl sm:text-2xl font-medium text-ink mb-3">Haftung für Inhalte</h2>
              <p className="text-sm">
                Die Inhalte dieser Website wurden mit Sorgfalt erstellt. Für die Richtigkeit,
                Vollständigkeit und Aktualität der Inhalte kann jedoch keine Gewähr übernommen
                werden. Für Inhalte externer Links, auf die diese Website verweist, sind
                ausschließlich deren Betreiber verantwortlich.
              </p>
            </section>
          </div>
        </div>
      </main>
      <Footer />
    </>
  );
}
